import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "medium-table"
}
const _hoisted_2 = { class: "buttons" }

import RateTable from '@/components/tables/RateTable.vue';
import { useSettingsStore } from '@/stores/setting';
import { onMounted, reactive } from 'vue';
import RateFormModal from '@/components/modals/RateFormModal.vue';
import { useVfm } from 'vue-final-modal';
import { RateItem } from '@/services/entities/RateItem';
import ConfirmModal from "@/components/modals/ConfirmModal.vue";
import Loader from '@/components/util/Loader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'RatesView',
  setup(__props) {

const settingsStore = useSettingsStore();
const rateModalId = Symbol("rateModal");
const confirmModalId = Symbol("confirmModal");
const vfm = useVfm();

onMounted(async () => {
  await settingsStore.loadRates();
});

const state = reactive({
  value: {} as RateItem,
  reteIdForDeletion: {} as string,
});

async function create() {
  await settingsStore.createRate(state.value);
  vfm.close(rateModalId)
  state.value = {} as RateItem;
}

async function edit() {
  await settingsStore.updateRate(state.value);
  vfm.close(rateModalId)
  state.value = {} as RateItem;
}

function showEditRate(rateId: string) {
  state.value = settingsStore.getRates.find(a => a.id == rateId) as RateItem;
  vfm.open(rateModalId);
}

async function closeModal() {
  vfm.close(rateModalId);
  state.value = {} as RateItem;
  settingsStore.loadRates();
}

function askDeleteRate(rateId: string) {
  state.reteIdForDeletion = rateId;
  vfm.open(confirmModalId);
}

async function confirmDelete(){
  vfm.close(confirmModalId);
  await deleteRate();
}

async function deleteRate() {
  await settingsStore.deleteRate(state.reteIdForDeletion);
  state.value = {} as RateItem;
  state.reteIdForDeletion = {} as string;
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(settingsStore).getRatesLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(RateTable, {
            data: _unref(settingsStore).getRates,
            onEdit: showEditRate,
            onDelete: askDeleteRate
          }, null, 8, ["data"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "accent",
              onClick: _cache[0] || (_cache[0] = () => _unref(vfm).open(_unref(rateModalId)))
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("b", null, "+", -1),
              _createTextVNode(" Add rate", -1)
            ]))])
          ])
        ]))
      : (_openBlock(), _createBlock(Loader, { key: 1 })),
    _createVNode(RateFormModal, {
      value: state.value,
      "modal-id": _unref(rateModalId),
      onClose: closeModal,
      onCreate: create,
      onEdit: edit
    }, null, 8, ["value", "modal-id"]),
    _createVNode(ConfirmModal, {
      "modal-id": _unref(confirmModalId),
      text: "Do you realy want to delete selected ?",
      "confirm-text": "Delete",
      onConfirm: confirmDelete,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(vfm).close(_unref(confirmModalId))))
    }, null, 8, ["modal-id"])
  ], 64))
}
}

})